import { Group, Text } from "@mantine/core";

interface CompanyResultsSummaryProps {
  jobTitles: number;
  jobPosts: number;
}

export function CompanyResultsSummary({ jobTitles, jobPosts }: CompanyResultsSummaryProps) {
  if (!jobTitles && !jobPosts) return null;

  return (
    <Group gap={4}>
      {jobTitles && (
        <Text c="gray.6" fz={{ base: 11, sm: "xs" }}>{`${jobTitles} Job ${
          jobTitles > 1 ? "Titles" : "Title"
        }`}</Text>
      )}
      {jobTitles && jobPosts && " · "}
      {jobPosts && (
        <Text c="gray.6" fz={{ base: 11, sm: "xs" }}>{`${jobPosts} Job ${
          jobPosts > 1 ? "Posts" : "Post"
        }`}</Text>
      )}
    </Group>
  );
}
